<script setup>

import {ref, onMounted, onUnmounted} from 'vue';
import App from '@/Layouts/App.vue';
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    pageAboutUs: Array,
    aboutUsDetail: Array,
    aboutUs: Array
})

const isMobile = ref(false);

const checkScreenSize = () => {
    isMobile.value = window.innerWidth < 1024;
};

onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
});
</script>

<template>
    <App :isShowContactUs="true">
        <template v-for="item in pageAboutUs">
            <section class="relative bg-cover bg-center w-full height-banners"
                     :style="{ backgroundImage: `url(${getImage(item.image_banner)})` }"
            >
                <div class="absolute top-0 w-full h-full flex flex-col justify-center items-center gap-y-1 p-3 md:p-0">
                    <h1 class="text-title text-primaryColor text-center">{{ item.title }}</h1>
                    <p class="text-description text-grayBlackColor text-center width-description-banner"
                       v-html="item.description"></p>
                </div>
            </section>
        </template>


        <section>
            <div class="content-body py-5 md:py-10 content-padding">
                <div class="flex w-full h-full gap-x-10"
                     :class="{
                    'flex-col': isMobile
                }">
                    <div class="w-full xl:w-[40%]">
                        <template v-for="item in aboutUsDetail">
                            <img class="object-cover w-full min-h-[203px] md:h-full"
                                 :src="getImage(item.image_article)" alt="">
                        </template>
                    </div>

                    <div class="w-full xl:w-[60%] mt-5 md:mt-0">
                        <div class="w-full h-full flex flex-col justify-start gap-y-3 md:gap-y-5">
                            <template v-for="item in aboutUsDetail">
                                <h1 class="text-title-content">{{ item.title }}</h1>
                                <p class="text-description">{{ item.description }}</p>
                            </template>

                            <template v-for="(item, index) in aboutUs">
                                <div class="flex justify-center items-center gap-x-3">
                                    <img class="h-14" :src="getImage(item.image_thumbnail)" alt="">
                                    <div class="flex flex-col justify-start gap-y-1">
                                        <h2 class="text-title-content-sub">{{ item.title }}</h2>
                                        <p class="text-description">{{ item.description }}</p>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </App>
</template>
